import React, { useRef } from "react"
import cls from "classnames"
import OutlinedText, { OutlinedTextProps } from "../OutlinedText"
import styles from "./index.module.scss"
import { sfxPlay } from "@/assets/audios/sfx"
import { throttle } from "@/utils/utils"

interface OutlineButtonProps {
    text: string
    style?: React.CSSProperties
    onClick?: () => void
    className?: string
    disabled?: boolean
    noSound?: boolean
}

type RestProps = Omit<OutlinedTextProps, "text" | "wrap">

const OutlineButton: React.FC<OutlineButtonProps & RestProps> = ({
    text,
    style,
    onClick,
    className,
    disabled,
    noSound,
    ...restProps
}) => {
    const onClickRef = useRef(onClick)
    const disabledRef = useRef(disabled)
    onClickRef.current = onClick
    disabledRef.current = disabled

    const handleClick = useRef(
        throttle(() => {
            if (disabledRef.current) return
            if (!noSound) {
                sfxPlay("click")
            }
            onClickRef.current?.()
        }, 300),
    ).current
    return (
        <div
            className={cls(
                styles.button,
                disabled && styles.disabled,
                className,
            )}
            style={style}
            onClick={handleClick}
        >
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            <OutlinedText
                text={text}
                fontFamily="a한글세상B"
                {...(restProps as any)}
            />
        </div>
    )
}

export default OutlineButton
